import { Controller } from "@hotwired/stimulus";
import Quill from "quill";
import QuillMarkdown from "quilljs-markdown";

export default class extends Controller {

  static targets = ['container', 'input'];

  static values = {
    inline: Boolean
  }

  connect() {
    Quill.register('modules/QuillMarkdown', QuillMarkdown, true);
    const quill = new Quill(this.containerTarget, {
      modules: {
        toolbar: false,
        QuillMarkdown: {},
      },
      readOnly: false,
      theme: 'snow',
      formats: this.buildFormats()
    });

    const input = this.inputTarget;

    if (input.value !== null && input.value !== undefined && input.value !== '') {
      quill.clipboard.dangerouslyPasteHTML(input.value);
    }

    quill.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        this.autoLinkUrls(quill, delta);
      }

      if (quill.getText().trim().length === 0) {
        input.value = '';
      } else {
        input.value = quill.getSemanticHTML()
          .replaceAll('<p></p>', '<p><br/></p>')
          .replaceAll('&nbsp;', ' ');
      }
    });

    this.quillObject = quill;
  }

  autoLinkUrls(quill, delta) {
    const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;

    const text = quill.getText();
    const matches = [];
    let match;

    while ((match = urlRegex.exec(text)) !== null) {
      matches.push({
        index: match.index,
        length: match[0].length,
        url: match[0]
      });
    }

    matches.forEach(({ index, length, url }) => {
      const format = quill.getFormat(index, length);

      if (!format.link) {
        quill.formatText(index, length, 'link', url, 'silent');
      }
    });
  }

  buildFormats() {
    if (this.inlineValue) {
      return [
        'bold',
        'italic',
        'list',
        'link'
      ]
    } else {
      return [
        'bold',
        'italic',
        'list',
        'link',
        'header'
      ]
    }
  }

  handleChange(event) {
    this.quillObject.root.innerHTML = event.detail.content;
  }

}